module.exports = __webpack_public_path__ + "img/dialogPng.1c80eb51.png";